import React, {Fragment} from 'react';
import PropTypes from 'prop-types';
import BasicModal from "components/common/BasicModal";
import {Icon} from 'semantic-ui-react';
import {FormattedMessage} from 'react-intl';
import {isNoU} from "utils/DBUtils";
import * as ResourceApi from "api/resources";
import confirmationMessages from './confirmationMessages';
import {EmptyFunc} from "utils/DBUtils";

const extractDetailsForResource = (resourceId, resource, undelete) => {
    if (isNoU(resourceId) || isNoU(resource) || isNoU(confirmationMessages[resourceId.type])) {
        return null;
    }

    return confirmationMessages[resourceId.type](resource, undelete);
};

const DeleteConfirmationModal = (props) => {
    const resourceId = props.resourceId || {type: "", id: ""};
    const details = extractDetailsForResource(resourceId, props.resource, props.undelete);

    let headerString;
    let cancelString;
    let submitString;
    let iconName;

    if (resourceId.type === ResourceApi.Types.User) {
        if (props.undelete) {
            headerString = 'modal.undelete.user.header';
            cancelString = 'modal.undelete.user.cancel';
            submitString = 'modal.undelete.user.confirm';
            iconName = 'add user';
        } else {
            headerString = 'modal.delete.user.header';
            cancelString = 'modal.delete.user.cancel';
            submitString = 'modal.delete.user.confirm';
            iconName = 'remove user';
        }
    } else {
        if (props.undelete) {
            headerString = 'modal.undelete.header';
            cancelString = 'modal.undelete.cancel';
            submitString = 'modal.undelete.confirm';
            iconName = 'add circle';
        } else {
            headerString = 'modal.delete.header';
            cancelString = 'modal.delete.cancel';
            submitString = 'modal.delete.confirm';
            iconName = 'remove circle';
        }
    }

    return (
        <BasicModal
          header={<FormattedMessage id={headerString}/>}
          specialType={
              `delete-modal caution-modal delete-${resourceId.type.toLowerCase()}-modal caution-modal centered-modal fadeInUp animResponse`
          }
          dimmer={true}
          modalSize="small"
          actions={[
              {
                  label: <FormattedMessage id={cancelString}/>,
                  action: props.cancel,
                  disabled: props.deleting,
                  displayType: "menu-item"
              },
              {
                  label: (
                      <Fragment>
                        <Icon name={iconName} /><FormattedMessage id={submitString}/>
                      </Fragment>
                  ),
                  loading: props.deleting,
                  action: props.confirm,
                  displayType: "button",
                  primaryCheck: true,
              }
          ]}
        open={props.modalOpen}
        onClose={(props.deleting || props.undeleting) ? EmptyFunc : props.cancel}>
            {isNoU(details) ? undefined : details}
        </BasicModal>
    );
};

DeleteConfirmationModal.propTypes = {
    // whether to flip the messaging of this modal, if being used for un-deleting a resource.
    undelete: PropTypes.bool,

    deleting: PropTypes.bool,
    undeleting: PropTypes.bool,
    resource: PropTypes.object,
    resourceId: PropTypes.shape({
        id: PropTypes.string.isRequired,
        type: PropTypes.oneOf(ResourceApi.Types)
    }),
    confirm: PropTypes.func.isRequired,
    cancel: PropTypes.func.isRequired
};

DeleteConfirmationModal.defaultProps = {
    undelete: false
};

export default DeleteConfirmationModal;



// WEBPACK FOOTER //
// ./public/components/DeleteConfirmation/DeleteConfirmationModal.jsx